module.exports = __webpack_public_path__ + "img/about-us-jishu.37daa8b5.jpg";